<template>
    <div>
        <app-gridview
            v-bind:parentData = "{
                tabHeaders: this.dataHeader,
                tabItems: this.dataItems,
                pageTitle: this.pageTitle,
                search: this.search,
            }"
            v-on:EditItem="editItemHandler($event)"
            v-on:DeleteItem="deleteItemHandler($event)"
            v-on:NewPressed="newRecordHandler"
        ></app-gridview>
    </div>
</template>

<script>
import moment from 'moment';

import GridView from '../../../components/common/GridView';

export default {
    components: {
        'app-gridview': GridView
    },  
    
    data() {
        return {
            pageTitle: this.$t('payrollprocessrun.payoutcontrol'),
            dataHeader: [
                {text: this.$t('columns.actions'), value: 'action', sortable: false,width:'80px'},
                {text: this.$t('payrollprocessrun.payout'), value: 'payoutcode', width: '150px'},
                {text: this.$t('columns.description'), value: 'payoutdesc', width: '250px'},
                {text: this.$t('columns.startdate'), value: 'startdate', width: '130px'},
                {text: this.$t('columns.enddate'), value: 'enddate', width: '130px'},
                {text: this.$t('reportsparam.year'), value: 'pyyear', width: '100px'},
                {text: this.$t('reportsparam.month'), value: 'pymonth', width: '100px'},
                {text: this.$t('setuppayrolltype.payrolltype'), value: 'payrolltypecode', width: '150px'},
                {text: this.$t('payrollprocessrun.payrollgroup'), value: 'valvaluecode', width: '150px'},
                {text: this.$t('payrollprocessrun.exchangerate'), value: 'exchratecode', width: '150px'},
                {text: this.$t('setuptaxablerebategroup.frequency'), value: 'salfreqcode', width: '150px'},
                {text: this.$t('payrollprocessrun.payeelist'), value: 'payeelistcode', width: '120px'},
                {text: this.$t('columns.status'), value: 'pystatusdesc', width: '130px'},
                {text: this.$t('payrollprocessrun.allowinput'), value: 'allowinput', width: '60px'},
                {text: this.$t('payrollprocessrun.selfservice'), value: 'ssrel', width: '60px'},
                {text: this.$t('columns.remark'), value: 'remark', width: '200px'}
            ],
            dataItems: [],
            errMsg: '',
            search: this.$route.params.search,
        }
    },

    methods: {
        loadPayoutControls() {
            const vm = this;

            this.$store.dispatch('get', {url: '/payoutctrl/all'})
            .then(res => {
                vm.dataItems = res.data.rec;

                for (let i = 0; i < vm.dataItems.length; i++) {
                    if (vm.dataItems[i].startdate) {
                        vm.dataItems[i].startdate = moment(vm.dataItems[i].startdate).format('YYYY-MM-DD');
                    }

                    if (vm.dataItems[i].enddate) {
                        vm.dataItems[i].enddate = moment(vm.dataItems[i].enddate).format('YYYY-MM-DD');
                    }
                }
            })
            .catch(err => {
                vm.errMsg = err;
            });
        },

        editItemHandler(item) {
            this.$router.push({name: 'payoutcontroledit', params: { id: item.id, search: item.search } });
        },

        newRecordHandler() {
            this.$router.push({name: 'payoutcontrolnew'});
        }
    },

    mounted() {
        this.loadPayoutControls();
    }
}
</script>